import request from '@/utils/zsm-requets'
const live = '/zsm/api/live/'
/**
 * 短信发送验证码
 fan_num	粉丝数
 douyin_name 抖音名称
 frontId 前端id
 front_name 前端名称
 shop_id 门店id
 shop_name 门店名称
 first_id
 first_name
 sec_id
 sec_name
 batch_no
 */
export function createLive(params) {
  return request({
    url: live + 'create',
    method: 'post',
    params
  })
}

/* 查看直播申请列表
*  id
* */
export function getLive(id) {
  return request({
    url: live + 'get',
    method: 'post',
    params: { id }
  })
}

/* 查看直播申请列表
*  frontId  前端id
* */
export function listLive(frontId) {
  return request({
    url: live + 'list',
    method: 'post',
    params: { frontId }
  })
}

/* 获取最近一次*/
export function getLastestOne(frontId) {
  return request({
    url: live + 'getLastestOne',
    method: 'post',
    params: { frontId }
  })
}

